import { Grid } from '@mui/material';
import React from 'react';
import { makeStyles } from 'tss-react/mui';
import Experiences from './Containers/Experiences';
import ExternalJobQualifications from './Containers/ExternalJobQualifications';
import UnitFirstDayInstructions from './Containers/FirstDayInstructions';
import NurseToPatientRatio from './Containers/NurseToPatient';
import UnitOrderPriorities from './Containers/OrderPriorities';
import UnitReferences from './Containers/References';
import UnitDetails from './Containers/UnitDetails';
import ViewBestBets from './Containers/ViewBestBets';
import VirtualInterviewRating from './Containers/VirtualInterviewRating';
import WorkHistoryGap from './Containers/WorkHistoryGap';

const useStyles = makeStyles()({
  detailsBodyContainer: {
    width: 'auto',
    paddingLeft: '12px',
  },
  item: {
    paddingTop: '0px !important',
  },
});

export const UnitDetailsBody = () => {
  const { classes } = useStyles();

  return (
    <>
      <Grid container className={classes.detailsBodyContainer} spacing={3} id="unit-details-body">
        <Grid item xs={8} className={classes.item}>
          <Grid container spacing={3}>
            <Grid item xs={12}>
              <Experiences />
            </Grid>
            <Grid item xs={6} className={classes.item}>
              <UnitDetails />
            </Grid>
            <Grid item xs={6} className={classes.item}>
              <UnitFirstDayInstructions />
              <ExternalJobQualifications />
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={4} className={classes.item}>
          <UnitReferences />
          <WorkHistoryGap />
          <UnitOrderPriorities />
          <VirtualInterviewRating />
          <NurseToPatientRatio />
          <ViewBestBets />
        </Grid>
      </Grid>
    </>
  );
};

export default UnitDetailsBody;
